module.exports = __webpack_public_path__ + "img/0.6add5650.jpg";